import { clearSessionSignup } from '@/views/Signup/session';
import AuthorizationService from '@/api/AuthorizationService';
import {
  BUSINESS_ONBOARDING_UUID_CREATION,
  clearBusinessOnboardingDataFromLocalStorage
} from '@/store/modules/businessOnboarding';
import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import {
  TRACKING_START_SIGNUP_SESSION_KEY,
  removeOauthState
} from '../router-utils';

export class ClearOauthState implements IRouterMiddleware {
  private service = new AuthorizationService();

  canActivate(to: MiddlewareRoute, from: MiddlewareRoute): boolean {
    const allowedRouteNames = new Set([
      'merchant-connect-oauth',
      'login',
      'auth-callback',
      'welcome'
    ]);

    const allowedRoutesWithInitialPaths = [
      '/business-onboarding',
      '/online-business-onboarding'
    ];

    return (
      !allowedRoutesWithInitialPaths.some(path => to.path.startsWith(path)) &&
      !allowedRouteNames.has(to.name || '') &&
      this.service.userIsValidNotRefresh()
    );
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    clearSessionSignup();
    clearBusinessOnboardingDataFromLocalStorage();
    removeOauthState();
    localStorage.removeItem(TRACKING_START_SIGNUP_SESSION_KEY);
    localStorage.removeItem(BUSINESS_ONBOARDING_UUID_CREATION);
    next();
  }
}
